import React from 'react';
import { cn } from '../../utils/cn';

export interface RadioProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: string;
  description?: string;
}

export const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
  ({ className, label, description, id, checked, ...props }, ref) => {
    const inputId = id || `${props.name}-${props.value}`;

    return (
      <div className={cn('flex items-start gap-2', className)}>
        <div className="relative mt-0.5 shrink-0">
          <input
            ref={ref}
            id={inputId}
            type="radio"
            checked={checked}
            className="peer sr-only"
            {...props}
          />
          <label
            htmlFor={inputId}
            className={cn(
              'flex h-4 w-4 cursor-pointer items-center justify-center rounded-full border border-slate-300 bg-white',
              'peer-checked:border-[#0F6B66]',
              'peer-focus-visible:ring-2 peer-focus-visible:ring-[var(--app-primary)]',
              'peer-disabled:cursor-not-allowed peer-disabled:opacity-50'
            )}
          >
            {checked ? <span className="h-2 w-2 rounded-full bg-[#0F6B66]" /> : null}
          </label>
        </div>
        {(label || description) && (
          <div>
            {label ? (
              <label
                htmlFor={inputId}
                className="text-sm font-medium text-[var(--app-text)] cursor-pointer"
              >
                {label}
              </label>
            ) : null}
            {description ? (
              <p className="text-xs text-[var(--app-text-muted)]">{description}</p>
            ) : null}
          </div>
        )}
      </div>
    );
  }
);

Radio.displayName = 'Radio';
